const cards = [
  {
    id: 1,
    title: '韩漫精选：都市恋爱特辑',
    desc: '精选20部高分韩漫恋爱作品，从霸道总裁到纯情初恋，总有一部让你心动不已。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20artistic%20style%2C%20vibrant%20yet%20gentle%20colors%2C%20comic%20reading%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20simple%20background&width=400&height=480&seq=card-img-01&orientation=portrait',
    tag: '韩漫',
  },
  {
    id: 2,
    title: '日漫新番：2026夏季必追',
    desc: '本季日漫新番大盘点，奇幻冒险、校园日常、悬疑推理一网打尽，追更不迷路。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20artistic%20style%2C%20vibrant%20yet%20gentle%20colors%2C%20comic%20reading%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20simple%20background&width=400&height=480&seq=card-img-02&orientation=portrait',
    tag: '日漫',
  },
  {
    id: 3,
    title: '国漫崛起：玄幻修仙大合集',
    desc: '国漫玄幻题材强势崛起，斗破乾坤、绝世神医等热门作品全集免费畅读。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20artistic%20style%2C%20vibrant%20yet%20gentle%20colors%2C%20comic%20reading%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20simple%20background&width=400&height=480&seq=card-img-03&orientation=portrait',
    tag: '国漫',
  },
  {
    id: 4,
    title: '下拉式阅读：沉浸体验指南',
    desc: '羞羞漫画独有下拉式阅读模式，无需翻页，一气呵成，给你最流畅的追更体验。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20artistic%20style%2C%20vibrant%20yet%20gentle%20colors%2C%20comic%20reading%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20simple%20background&width=400&height=480&seq=card-img-04&orientation=portrait',
    tag: '体验',
  },
  {
    id: 5,
    title: '热门推荐：本周必看TOP10',
    desc: '编辑精选本周最值得追的10部漫画，涵盖韩漫日漫国漫，新人入坑首选清单。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20themed%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20artistic%20style%2C%20vibrant%20yet%20gentle%20colors%2C%20comic%20reading%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20simple%20background&width=400&height=480&seq=card-img-05&orientation=portrait',
    tag: '推荐',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-layout-grid-line text-primary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精选推荐</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">编辑精心挑选，发现你的下一部心头好</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-200">
                <img
                  src={card.imgUrl}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">{card.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}